import workerTimer from "./worker";
import axios from "axios";
import { Alert } from "element-ui";

// 定义 chathubService 类
export default class ChathubService {
  static instance = null;
  static get Instance() {
    if (!this.instance) {
      this.instance = new ChathubService();
    }
    return this.instance;
  }
  /** 和服务端连接的socket对象 */
  ws = null;
  /** 服务器连接地址 */
  wsUrl = null;
  token = null;
  Services = null;
  /** 标识是否连接成功 */
  connected = false;

  /** 重新连接间隔(ms) */
  connectRetryTime = 3000;
  /** 重新连接次数 */
  connectRetryCount = 0;
  timeout = 20 * 1000; //20秒一次心跳
  heartbeatInterval = null; //心跳倒计时
  lastRunTime = Date.now();

  // 最大重试次数
  userInfo = null;
  api = null;
  shoppingApi = null;
  token = null;
  isLogin = false;
  connectionId = null;
  connectionToken = null;
  /** 定义连接服务器的方法 */
  async connectChathubService(Services, userInfo, token) {
    // 连接服务器
    if (!window.WebSocket) {
      return console.log("您的浏览器不支持WebSocket");
    }
    this.token = token;
    this.Services = Services;
    this.wsUrl = Services.ChathubHubs;
    this.api = Services.Chathub;
    this.shoppingApi = Services.Shopping;
    this.userInfo = userInfo;
    this.negotiate = (e) => {
      return new Promise((resolve, reject) => {
        const negotiateUrl = `${this.wsUrl}/negotiate?negotiateVersion=1`;
        axios({
          method: "POST",
          url: negotiateUrl,
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((res) => {});
      });
    };
    /**
     * 客服登录
     * @param {*} e
     */
    this.OnConnectionLogin = async (e) => {
      let url = "";
      if (Services.ClientId == Services.QYClient) {
        let shopName = await this.getShopInfo();
        if (!shopName) {
          Alert("未开通店铺！");
          return;
        }
        url = this.api + `/api/ChatHub/OnConnectionLogin?userId=${this.userInfo.id}&clientId=${this.connectionId}&userName=${this.userInfo.name}&isWX=false&shopName=${shopName}`;
      }
      if (Services.ClientId == Services.YunClient || Services.ClientId == Services.AssociationClient || Services.ClientId == Services.FairClient) {
        url = this.api + `/api/ChatHub/OnConnectionLogin?userId=${this.userInfo.id}&clientId=${this.connectionId}&userName=${this.userInfo.name}&isWX=false&shopName=%20&orgId=${this.userInfo.organizationId}`;
      }
      console.log(url)
      axios({
        method: "POST",
        headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer" + " " + this.token },
        // 这里是你的上传地址
        url: url,
      })
        .then((res) => {
          console.log("聊天登录成功");
          window.dispatchEvent(
            new CustomEvent("onConnected", {
              detail: {
                data: this.connected,
              },
            })
          );
        })
        .catch((res) => {
          console.log("聊天登录失败", res);
        });
    };
    /**
     * 获取店铺信息
     * @param {*} e
     * @returns
     */
    this.getShopInfo = async (e) => {
      return new Promise((resolve, reject) => {
        axios({
          method: "GET",
          headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer" + " " + this.token },
          // 这里是你的上传地址
          url: this.shoppingApi + `/api/Merchant/Set/${this.userInfo.organizationId}`,
        })
          .then((res) => {
            if (res.data.data.id) sessionStorage.setItem("shopId", res.data.data.id);
            resolve(res.data.data.shopName);
          })
          .catch((res) => {
            console.log("获取店铺信息失败", res);
            resolve(false);
          });
      });
    };
    // 发送心跳
    this.start = () => {
      this.heartbeatInterval = workerTimer.setInterval(() => {
        let ping = { type: 6 };
        this.sendWebsocket(JSON.stringify(ping) + "\u001E"); // 发送心跳消息
      }, this.timeout);
    };
    let res = await this.negotiate();
    this.connectionId = res.connectionId;
    this.connectionToken = res.connectionToken;
    this.ws = new WebSocket(`${this.wsUrl}?id=${this.connectionToken}`);
    // 连接成功的事件
    this.ws.onopen = () => {
      console.log("ChathubSocket连接服务端成功,您的连接地址：" + this.wsUrl);
      this.connected = true;
      // 重置重新连接的次数
      this.connectRetryCount = 0;
      this.OnConnectionLogin();
      this.start();
      const initMessage = {
        protocol: "json",
        version: 1,
        type: 1, // 初始化消息
      };
      this.sendWebsocket(JSON.stringify(initMessage) + "\u001E");
    };

    // 发送消息到WebSocket服务器
    this.sendWebsocket = (e) => {
      console.log("Chathub发送消息", e);
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(e);
      }
    };
    //服务器返回的数据
    this.ws.onmessage = (e) => {
      let msg = e.data.replace(String.fromCharCode(0x1e), "");
      let msgData = JSON.parse(msg);
      console.log("Chathub返回的数据", msgData);
      if (msgData.type == 1 && msgData.target == "ReceiveToUserMsg") {
        let data = JSON.stringify(msgData.arguments[0]);
        window.dispatchEvent(
          new CustomEvent("ReceiveToUserMsg", {
            detail: {
              data: data,
            },
          })
        );
      }
    };
    // 1.连接服务端失败
    // 2.当连接成功之后, 服务器关闭的情况
    this.ws.onclose = () => {
      console.log("Chathub服务器关闭");
      this.connected = false;
      this.stop();
    };
    //连接服务端失败
    this.ws.onerror = (e) => {
      console.log("Chathub连接服务端失败");
      this.connected = false;
      this.stop();
      this.reconnect();
    };

    // 关闭心跳
    this.stop = () => {
      console.log("Chathub关闭心跳");
      if (this.heartbeatInterval) {
        workerTimer.clearInterval(this.heartbeatInterval); // 停止心跳检测定时器
        // clearInterval(this.heartbeatInterval); // 停止心跳检测定时器
      }
    };
    //关闭连接
    this.close = (e) => {
      if (this.ws) {
        console.log("Chathub关闭连接");
        // Speech.cancel()  // 取消播放
        // Speech = null;
        this.ws.close();
      }
    };
    //重新连接
    this.reconnect = (e) => {
      this.connectRetryCount++;
      if (this.connectRetryCount >= 10) {
        console.log("ChathubSocket出错,已断开连接");
      } else {
        console.log("ChathubSocket出错:第" + this.connectRetryCount + "次重新连接尝试！");
        setTimeout(async () => {
          this.connectChathubService(this.wsUrl, this.api, this.shoppingApi, this.userInfo, this.token);
        }, this.connectRetryTime); // 在一定时间后重连 WebSocket
      }
    };
  }
}
